import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Progress, Button } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { withTranslation } from 'react-i18next';

import styles from './Header.scss';
import { GACategories, GAActions } from '../../analytics';
import { handleGAEvent, isInterviewDeveloper } from '../../helperFunctions';
import { get_image_endpoint } from '../../ImageEndpoint';
import { TRIGGER_BY_USER } from '../../const';
import {
  switchToNextSection,
  showLastSectionCompletionModal,
  showSubmitSectionConfirmModal,
} from '../../Utils/sectionUtils';
import * as actions from '../../store/actions/AssessmentActions';
import SectionTimer from './SectionTimer';
import OverallTimer from './OverallTimer';

class Header extends Component {
  handleSubmitTestButton = () => {
    this.props.submitTest(this.props.assessmentId);
  };

  handleEndInterview = () => {
    this.props.submitInterview();
  };

  onSubmitSection = () => {
    switchToNextSection({
      sections: this.props.sections,
      currentSectionId: this.props.currentSectionId,
      history: this.props.history,
      assessmentId: this.props.assessmentId,
      endBy: TRIGGER_BY_USER,
      submitTest: this.props.submitTest,
    });
  };

  isOverallMode = () => {
    return this.props.switchableSections || !this.props.sections.length;
  };

  sectionSubmission = () => {
    const currentSectionIndex = this.props.sections.findIndex(
      section => section.id === this.props.currentSectionId,
    );
    if (currentSectionIndex === this.props.sections.length - 1) {
      showLastSectionCompletionModal(
        this.props.dispatch,
        actions,
        this.props.currentSectionId,
        this.props.assessmentId,
      );
    } else {
      showSubmitSectionConfirmModal(this.props.dispatch, this.onSubmitSection);
    }
  };

  render() {
    const { t } = this.props;

    let isInterviewer = false;
    if (this.props.participants) {
      isInterviewer = isInterviewDeveloper(this.props.participants);
    }

    let timer = this.isOverallMode() ? (
      <OverallTimer
        submitTest={this.props.submitTest}
        assessmentId={this.props.assessmentId}
        setTimerExpLevel={this.props.setTimerExpLevel}
      />
    ) : (
      <SectionTimer
        initialTime={this.props.sectionRemainingTime * 1000}
        setTimerExpLevel={this.props.setTimerExpLevel}
        submitTest={this.props.submitTest}
      />
    );

    return (
      <div>
        <div className={styles['l-header']}>
          {this.props.company_details.alias ? (
            <div className={styles['c-logo']}>
              <img
                src={get_image_endpoint(this.props.company_details.alias, 'dark')}
                className={styles['c-logo__image']}
                alt={`${this.props.company_details.name} logo`}
                onClick={this.goToHomePage}
              />
            </div>
          ) : (
            <div className={styles['c-logo']} />
          )}

          {this.props.partialHeader === 'false' ? (
            <>
              <div className={styles['c-problem-counter']}>
                {this.isOverallMode() ? (
                  <ClockCircleOutlined style={{ fontSize: '18px' }} />
                ) : (
                  t('header.section_timer')
                )}
                <span>&nbsp;&nbsp;&nbsp;{timer}</span>
              </div>

              {!window.location.pathname.includes('/section/') && (
                <Button
                  type="primary"
                  size="large"
                  style={{
                    fontSize: '18px',
                    fontWeight: '500',
                    borderRadius: '2px',
                    height: '50px',
                    width: '180px',
                    marginLeft: 'auto',
                  }}
                  onClick={handleGAEvent(
                    this.isOverallMode() ? this.handleSubmitTestButton : this.sectionSubmission,
                    GACategories.assessment,
                    this.props.switchableSections ? GAActions.submitTest : GAActions.submitSection,
                  )}
                >
                  {this.isOverallMode() ? t('header.submit_test') : t('header.submit_section')}
                </Button>
              )}
            </>
          ) : isInterviewer &&
            !window.location.pathname.includes('/feedback') &&
            this.props.current_interview_page === 'meeting' ? (
            <div style={{ marginLeft: 'auto' }}>
              <Button
                type="primary"
                size="large"
                style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  borderRadius: '5px',
                  padding: '0.25vw 1vw',
                  width: '120px',
                  height: '32px',
                }}
                onClick={this.handleEndInterview}
              >
                {t('header.end_interview')}
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  company_details: state.auth.company_details,
  current_interview_page: state.meeting.current_page,
  sections: state.assessment.sections,
  currentSectionId: state.assessment.currentSectionId,
  sectionRemainingTime: state.assessment.sections?.find(
    section => section.id === state.assessment.currentSectionId,
  )?.remaining_time,
  remainingTime: state.assessment.remainingTime,
  switchableSections: state.assessment.switchableSections,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  updateSectionStatus: (sectionId, status) =>
    dispatch(actions.updateSectionStatus(sectionId, status)),
  setCurrentSectionId: sectionId => dispatch(actions.setCurrentSectionId(sectionId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(withTranslation('common')(Header)));
